package presentation.screens.business.inventory.product.create.component

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.text.input.VisualTransformation
import androidx.compose.ui.unit.dp
import common.asset.ImageAsset
import component.input.CustomTextField
import feature.product.viewModel.ProductViewModel

@Composable
fun CreateProductPricing(viewModel: ProductViewModel) {
    val product = viewModel.newProduct.collectAsState()
    val nameErrorState = remember { mutableStateOf(false) }
    Column(
        modifier = Modifier.fillMaxWidth().padding(bottom = 10.dp)
    ) {
        CustomTextField(
            value = product.value?.ProductPrice?.MRP?.toString() ?: "",
            placeholder = "MRP/Price written on the product",
            trailingIcon = ImageAsset.person,
            label = "MRP",
            errorState = nameErrorState.value,
            keyboardType = KeyboardType.Number,
            visualTransformation = VisualTransformation.None
        ) { newValue ->
            viewModel.setNewProductMrpPrice(newValue.text)
        }
        CustomTextField(
            value = product.value?.ProductPrice?.CostPrice?.toString() ?: "",
            placeholder = "Price on which you purchased",
            trailingIcon = ImageAsset.person,
            label = "Cost Price",
            errorState = nameErrorState.value,
            keyboardType = KeyboardType.Number,
            visualTransformation = VisualTransformation.None
        ) { newValue ->
            viewModel.setNewProductCostPricePrice(newValue.text)
        }

    }
}